import { init, send } from "@emailjs/browser";

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_1i8ogel";
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_contact";
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_EMAILJS_PUBLIC_KEY";

let emailJsInitialized = false;

export function initEmailJs() {
  if (!emailJsInitialized) {
    if (!EMAILJS_PUBLIC_KEY || EMAILJS_PUBLIC_KEY === "YOUR_EMAILJS_PUBLIC_KEY") {
      console.warn("EmailJS public key is not configured. Set REACT_APP_EMAILJS_PUBLIC_KEY in your .env.");
      return;
    }
    init(EMAILJS_PUBLIC_KEY);
    emailJsInitialized = true;
  }
}

export async function sendEmailJS(templateParams) {
  initEmailJs();
  if (!emailJsInitialized) {
    throw new Error("EmailJS is not initialized because the public key is missing.");
  }
  return send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams);
}
